<template>
    <div class="lawEnforcement_detail">
        <el-dialog
            title="配置项"
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            :before-close="handleClose">
                <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="检查编码：" prop="code">
                                <el-input v-model="form.code" clearable placeholder="请输入检查编码"></el-input>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="检查环节：" prop="type">
                                <el-select v-model="form.type" clearable style="width:100%;">
                                    <el-option label="开标" :value="1"></el-option>
                                    <el-option label="评标" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="检查内容：" prop="content">
                                <el-input type="textarea" rows="4" v-model="form.content" clearable placeholder="请输入检查内容"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="序号：" prop="sort">
                                <el-input v-model="form.sort" clearable placeholder="请输入序号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8" :offset="18">
                            <el-button @click="handleClose">取消</el-button>
                            <el-button v-debounce="[submit,'click',300,'form']" type="primary" >确定</el-button>
                        </el-col>
                    </el-row>
                </el-form>
        </el-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import {isMobile,isIdcard} from '@/utils/validate'
import {syscheckitemconfigSingle,syscheckitemconfigSave} from '@/server/bidCheckConfigItem'
export default {
    data(){
        return{
            dialogVisible:false,
            form:{
                id:"",
                code:'',
                sort:'',
                type:'',
                content:'',
                remark:'',
                tradeId:'',
            },
            rules:{
                type: [
                    {required: true, message: '请选择检查环节', trigger: 'blur'}
                ],
                code: [
                    {required: true, message: '请输入检查编码', trigger: 'blur'}
                ],
                sort: [
                    {required: true, message: '请输入检查编码', trigger: 'blur'}
                ],
                content: [
                    {required: true, message: '请输入检查内容', trigger: 'blur'}
                ],
            },
            witnessStatuslist:[]
        }
    },

    computed:{
      ...mapState({
        isAdmin: state => {return state.user.userinfo.selectRoleCode == "ADMIN"}
    }),
    },
    methods:{
        handleClose(){
            this.$refs['form'].resetFields();
            this.dialogVisible=false;
            this.form={};
            Object.assign(this.$data.form, this.$options.data().form)
            this.$emit('handleClose',true)
        },
        submit(form){
             this.$refs[form].validate(valid => {
                if (valid) {
                    syscheckitemconfigSave(this.form).then(res => {
                        if(res.data.code==1){
                            this.$message.success(res.data.msg)
                            this.handleClose();
                        }else{
                            this.$message.error(res.data.msg)
                        }
                    })
                }
             })
        },
        getSingle(id){//单个查询
            syscheckitemconfigSingle(id).then(res => {
                if(res.data.code==1){
                    console.log(res.data.data)
                    this.form=res.data.data;
                    // this.form.type = this.form.type.toString();
                }
            })
        }
    },
    mounted(){
        
    }
}
</script>
<style lang="scss" scoped>
    /deep/ .el-dialog{
        width: 700px;
    }
    .el-form{
        margin: 20px 90px 30px 20px;
    }
</style>
